import withConfigTransport from '../../../services/config-transport/withConfigTransport'
import _VaTreeCategory from './VaTreeCategory.vue'

export const VaTreeCategory = withConfigTransport(_VaTreeCategory)
